import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Transmogrifier from "./Transmogrifier";
import { useLogEvent } from "../../contexts/Analytics";

export default function LevelUp({ champ, level, isOpen, onClose }) {
  const award = get(champ, `levelUpCertificate${level}`);
  const jwPlayerId = get(champ, "phaseTransition.video.jwPlayerId");

  const { logEvent } = useLogEvent({
    event: "Champ Achievement Printed",
    options: { referrer: () => {} },
  });

  if (!jwPlayerId || !level) {
    return null;
  }

  return (
    <Transmogrifier
      title={`You leveled up ${champ.name}`}
      award={award}
      jwPlayerId={jwPlayerId}
      isOpen={isOpen}
      action="Continue GoNoodling"
      onActionClick={onClose}
      onPrintAward={() =>
        logEvent({ champName: champ.name, level: String(level) })
      }
    />
  );
}

LevelUp.propTypes = {
  champ: PropTypes.shape({
    name: PropTypes.string.isRequired,
    levelUpCertificate2: PropTypes.string.isRequired,
    levelUpCertificate3: PropTypes.string.isRequired,
    levelUpCertificate4: PropTypes.string.isRequired,
    graduationCertificate: PropTypes.string.isRequired,
  }),
  level: PropTypes.number.isRequired,
  isOpen: Transmogrifier.propTypes.isOpen,
  onClose: PropTypes.func.isRequired,
};
